import Vue from 'vue'

/* eslint-disable */
export const makeGetRequest = async (url, config = {}) => {
  const res = await Vue.axios.get(url, config)
  return res.data
}
